module.exports = __webpack_public_path__ + "static/img/1.1c8842d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R417A/1.jpg
// module id = JCJB
// module chunks = 1